export default function (inputDateString: number): number {

  return Math.floor(inputDateString * 10) / 10;

}
